import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UtilityService } from '../utility.service';
import { BaseFormService } from '../BaseFormService';

@Injectable({
	providedIn: 'root',
})
export class ProjectGrantComplianceFormService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(
			`${environment.apiUrl}project-grant/clients/$$clientId$$/project-grant-compliance-form`,
			httpClient,
			utilityService
		);
	}

	submitDeliverables(clientId: string, formId: string, request: any): Observable<any> {
		const formData: FormData = new FormData();
		for (let i = 0; i < request.deliverables.length; i++) {
			const name = `deliverable-${i + 1}`;
			formData.append(name, request.deliverables[i].file);
			request.deliverables[i].file = null;
			request.deliverables[i].name = name;
		}

		formData.append('model', JSON.stringify(request));

		return this.httpClient.post<any>(`${this.getUrl(clientId)}/${formId}/deliverables`, formData).pipe();
	}

	cancelSchedule(id: string, clientId: string): Observable<any> {
		return this.httpClient.delete<any>(`${this.getUrl(clientId)}/${id}/cancelSchedule`).pipe();
	}

	getProjectGrantComplianceFormForScheduling(clientId: string, data: any): Observable<any[]> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/manage/scheduling`, data).pipe();
	}

	updateProjectGrantComplianceFormForScheduling(clientId: string, message: any): Observable<any[]> {
		return this.httpClient.post<any[]>(`${this.getUrl(clientId)}/manage/scheduling/update`, message).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}
}
